// ---------- MODAL HANDLING ----------
window.onload = function () {
  updateBBContent();
};

function openModalBB() {
  document.querySelector(".popup").style.display = "flex";
  document.querySelector(".popup").style.opacity = 1;
  document.querySelector(".popup-dialog").style.opacity = 1;
  removeClassIfWide();
}

function closeModalBB() {
  document.querySelector(".BB-modal").style.display = "none";
}

function removeClassIfWide() {
  const stickyElement = document.querySelector(".product-right-content-sticky");
  const featured = document.querySelector(".fc-bb");
  const related_product = document.querySelector(".rp-bb");

  if (stickyElement && window.innerWidth > 1024) {
    stickyElement.classList.remove("d-xl-block");
  }
  if (featured) featured.style.display = "none";
  if (related_product) related_product.style.display = "none";
}

function addClassIfWide() {
  const stickyElement = document.querySelector(".product-right-content-sticky");
  const featured = document.querySelector(".fc-bb");
  const related_product = document.querySelector(".rp-bb");

  if (stickyElement && window.innerWidth > 1024) {
    setTimeout(() => stickyElement.classList.add("d-xl-block"), 1000);
  }
  if (featured) setTimeout(() => (featured.style.display = "block"), 1000);
  if (related_product) setTimeout(() => (related_product.style.display = "block"), 1000);
}

const closeButton = document.querySelector(".BB-modal .popup-close");
if (closeButton) {
  closeButton.addEventListener("click", addClassIfWide);
}

// ---------- PRICE OBSERVER ----------
function setupPriceObserver() {
  const targetNode = document.querySelector(".price-item");
  if (!targetNode) return;

  const observer = new MutationObserver(() => updateBBContent());
  observer.observe(targetNode, { subtree: true, childList: true, characterData: true });

  updateBBContent();
}

document.addEventListener("DOMContentLoaded", setupPriceObserver);

// ---------- BUYBACK CALCULATION (5% REDUCING BALANCE) ----------

function reducingBalancePercentage(months) {
  return Math.pow(0.95, months) * 100; // 5% per month reducing balance
}

function updateBBContent() {
  const element = document.querySelector(".price-item");
  if (!element) return;

  const content = element.textContent;
  const numericString = content.replace("₹ ", "").replace(",", "");
  const originalAmount = parseFloat(numericString);

  // 30 days = 1 month, 180 days = 6 months
  const percentageB1 = reducingBalancePercentage(1);
  const percentageB2 = reducingBalancePercentage(6);

  const numToAdd = parseInt(originalAmount * (percentageB1 / 100));
  const numToAdd2 = parseInt(originalAmount * (percentageB2 / 100));

  const targetDiv = document.querySelector(".buy-b-price");
  const targetDiv2 = document.querySelector(".buy-b-price-2");

  if (targetDiv) targetDiv.innerHTML = numToAdd;
  if (targetDiv2) targetDiv2.innerHTML = numToAdd2;
}

// ---------- SLIDER / MONTHLY CALC UPDATE ----------
const priceSpan = document.querySelector(".buy-b-price-2");
const selectedYearSpan = document.getElementById("selectedYear");


function updatePriceBB2(months) {
  if (selectedYearSpan) {
    selectedYearSpan.textContent = months;
  }


  const element = document.querySelector(".price-item");
  if (!element || !priceSpan) return;


  const content = element.textContent || "";
  const numericString = content.replace(/[₹,\s]/g, "");
  const originalAmount = parseFloat(numericString);


  if (isNaN(originalAmount)) return;


  const dynamicPercentage = reducingBalancePercentage(months);
  const numToAdd = parseInt(originalAmount * (dynamicPercentage / 100));


  priceSpan.textContent = numToAdd;
}


// Set default 6 months (only if elements exist)
if (priceSpan || selectedYearSpan) {
  updatePriceBB2(6);
}


// ---------- POPUP CLICK ----------
const BB_popup = document.getElementById("bb");
if (BB_popup) {
  BB_popup.addEventListener("click", function (event) {
    if (!BB_popup.contains(event.target)) {
      addClassIfWide();
    }
  });
}
